
import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { getRestaurantMetaInfo } from '@/utils/meta';
import BannerContainer from '@/components/shared/BannerContainer.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

const namespace: string = 'auth';

@Component<ProfileIndex>({
	components: {
		BannerContainer,
		LoadingSpinner
	},
	metaInfo() {
		return getRestaurantMetaInfo(this.restaurant);
	}
})
export default class ProfileIndex extends Vue {
	@Action('fetchRestaurant', { namespace: 'restaurant' }) private fetchRestaurant!: (payload: FetchRestaurantPayload) => Promise<boolean>;
	@Getter('getRestaurant', { namespace: 'restaurant' }) private restaurant!: Restaurant;
	@Getter('hasCssLoaded', { namespace: 'restaurant' }) private cssLoaded!: boolean;
	@Getter('getUser', { namespace }) private user!: UserInfo;
	@Getter('showLoginAsBanner', { namespace }) private showLoginAsBanner!: boolean;

	private dataFetched: boolean = true;

	private get fullName(): string {
		return (this.user.firstName || this.user.lastName) ? `${this.user.firstName} ${this.user.lastName}` : '';
	}

	private get profileBanners(): BannerItem[] {
		return [
			{
				name: 'login-as',
				type: 'info',
				show: !!(this.showLoginAsBanner && this.fullName),
				message: this.showLoginAsBanner ? this.$t('menu.logged_in_as_banner') : this.$t('menu.welcome_back_banner'),
				action: {
					text : this.fullName,
					onClick : () => this.$router.push({ path: '/profile', query: this.$route.query, hash: this.$route.hash }).catch(() => {})
				}
			}
		];
	}

	private async created(): Promise<void> {
		if (!this.restaurant?.name) {
			const restaurantSlug: string | null = sessionStorage.getItem('restaurantSlug');

			if (restaurantSlug) {
				this.dataFetched = false;
				try {
					await this.fetchRestaurant({
						restaurantSlug,
						route: this.$route,
						router: this.$router
					});
				}
				catch (error) {
					if (error.errorMessage) {
						this.$toasted.show(error.errorMessage, { type: 'error', position: 'top-center' }).goAway(5000);
					}
				}
				finally {
					this.dataFetched = true;
				}
			}
		}
	}
}
